<template>
  <v-dialog
    v-model="dialogAtivo"
    width="1300"
    content-class="bra-20"
    transition="dialog-top-transition"
  >
    <template #activator="{ on: on_dialog, attrs: attrs_dialog }">
      <v-tooltip open-delay="500" top>
        <template #activator="{ on, attrs }">
          <v-btn :disabled="disabled" x-small icon v-bind="attrs" v-on="on" @click.stop="abrirOuFecharDialog">
            <v-icon small v-text="'mdi-information-outline'" />
          </v-btn>
        </template>
        <span>
          Click para ver o estoque por
          <template v-if="tipo_filiais === 'cds'">CD</template>
          <template v-else-if="tipo_filiais === 'lojas'">loja</template>
          <template v-else>filial</template>
        </span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        <span>
          Estoque por
          <template v-if="tipo_filiais === 'cds'">CD</template>
          <template v-else-if="tipo_filiais === 'lojas'">loja</template>
          <template v-else>filial</template>
        </span>
        <v-spacer />

        <v-btn icon @click.stop="abrirOuFecharDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pl-10">
        <slot name="topo-tabela" />

        <table id="table">
          <thead>
          <tr class="text-left">
            <th style="border: 0" />
            <th class="bg-lado-esquerdo" colspan="6">Quantitativo</th>
            <th class="bg-lado-direito" colspan="6">Financeiro</th>
          </tr>
          <tr class="text-left">
            <template v-for="(header, index) in headers">
              <th :key="index" :class="header.class" v-text="header.text" />
            </template>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(item, _index) in itens" :key="_index">
            <template v-for="(header, index) in headers">
              <td
                v-if="header.value === 'diferenca_entre_estoques'"
                :key="index"
                :class="header.class"
                class="d-flex align-center text-truncate"
              >
                <v-icon v-if="item.diferenca_entre_estoques < 0" small color="green">mdi-arrow-up</v-icon>
                <v-icon v-else-if="item.diferenca_entre_estoques > 0" small color="red">mdi-arrow-down</v-icon>

                <div v-text="`${Helpers.formatarValor(Math.abs(item.diferenca_entre_estoques))}%`" class="px-1 w-full" />

                <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{on, attrs}">
                    <v-btn icon x-small v-bind="attrs" v-on="on" @click="irParaTelaDeDrp">
                      <v-icon small>$ArrowTopRightThinCircleOutline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ir para tela de Logística - DRP</span>
                </v-tooltip>
              </td>

              <td v-else :key="index" :class="header.class">
                  <span
                    v-text="item[header.value] || ''"
                    :class="item.filial === 'Todas as lojas' ? 'font-weight-bold' : ''"
                  />
              </td>
            </template>
          </tr>

          <tr v-if="!itens || itens.length === 0">
            <td :colspan="headers.length" style="height: 50px" class="text-left">
              Carregando dados... aguarde
            </td>
          </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FilialAPI from "../../../api/filial.js";
import {formatarValor, formatarValorMonetario, logout} from "../../../helpers";

export default {
  name: "EstoquePorLojaDialog",
  props: {
    disabled: Boolean,
    parametros: {
      type: Object,
      required: true
    },
    tipo_filiais: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    dialogAtivo: false,
    headers: [
      {text: 'Loja', value: 'filial', class: 'bg-lado-esquerdo'},
      {text: 'Projeção de vendas', value: 'projecao_venda', class: 'bg-lado-esquerdo'},
      {text: 'Saldo de estoque atual', value: 'estoque', class: 'bg-lado-esquerdo'},
      {text: 'Cobertura atual', value: 'cobertura_instantanea_dias', class: 'bg-lado-esquerdo'},
      {text: 'Saldo de estoque ideal', value: 'estoque_ideal', class: 'bg-lado-esquerdo'},
      {text: 'Cobertura ideal', value: 'cobertura_drp_dias', class: 'bg-lado-esquerdo'},
      {text: 'Diferença', value: 'diferenca_entre_estoques', class: 'bg-lado-esquerdo'},
      {text: 'Projeção de vendas preço custo', value: 'projecao_venda_preco_custo',  class: 'bg-lado-direito'},
      {text: 'Estoque preço custo', value: 'estoque_preco_custo',  class: 'bg-lado-direito'},
      {text: 'Estoque ideal preço custo', value: 'estoque_ideal_preco_custo',  class: 'bg-lado-direito'},
      {text: 'Projeção de vendas preço venda', value: 'projecao_venda_preco_venda',  class: 'bg-lado-direito'},
      {text: 'Estoque preço venda', value: 'estoque_preco_venda',  class: 'bg-lado-direito'},
      {text: 'Estoque ideal preço venda', value: 'estoque_ideal_preco_venda',  class: 'bg-lado-direito'},
    ],
    itens: []
  }),
  methods: {
    abrirOuFecharDialog() {
      this.dialogAtivo = !this.dialogAtivo;

      if (this.dialogAtivo) {
        this.buscarEstoquePorLoja();
      }
    },
    buscarEstoquePorLoja() {
      this.itens = [];

      const parametros = {
        iddepartamento: this.parametros.iddepartamento || undefined,
        idsecao: this.parametros.idsecao || undefined,
        idcategoria: this.parametros.idcategoria || undefined,
        idproduto: this.parametros.idproduto || undefined,
        id_grupo: this.parametros.grupo,
        tipo_filiais: this.tipo_filiais
      };

      this.$store.dispatch('loading/addRequisicao',
        FilialAPI.buscarEstoquePorFilial(parametros)
          .then(estoques => (this.itens = estoques.map(this.formatarItemTabela)))
          .catch(logout)
      );
    },
    formatarItemTabela(item) {
      item.estoque = formatarValor(item.estoque);
      item.cobertura_instantanea_dias = `${formatarValor(item.cobertura_instantanea_dias)} dias`;
      item.projecao_venda = formatarValor(item.projecao_venda);
      item.cobertura_drp_dias = `${formatarValor(item.cobertura_drp_dias)} dias`;
      item.estoque_ideal = formatarValor(item.estoque_ideal);

      item.estoque_preco_custo = formatarValorMonetario(item.estoque_preco_custo);
      item.estoque_preco_venda = formatarValorMonetario(item.estoque_preco_venda);
      item.estoque_ideal_preco_custo = formatarValorMonetario(item.estoque_ideal_preco_custo);
      item.estoque_ideal_preco_venda = formatarValorMonetario(item.estoque_ideal_preco_venda);
      item.projecao_venda_preco_custo = formatarValorMonetario(item.projecao_venda_preco_custo);
      item.projecao_venda_preco_venda = formatarValorMonetario(item.projecao_venda_preco_venda);

      return item;
    },
    irParaTelaDeDrp() {
      this.$router.push({name: 'drp'})
    }
  }
}
</script>

<style scoped>
#table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
#table tr th {
  font-weight: 700;
  font-size: 13px;
  padding: 0 5px;
  text-align: center;
}
#table tr td {
  color: #1a1a1a;
  font-size: 12px;
  height: 44px;
  padding: 0 5px;
  text-align: center;
}
#table tr td, #table tr th {
  border-top: 1px solid #e0d8d8;
  border-left: 1px solid #e0d8d8;
}
#table tr td:last-child, th:last-child {
  border-right: 1px solid #e0d8d8;
}
#table tr:last-child td {
  border-bottom: 1px solid #cbc3c3;
}
.bg-lado-esquerdo {
  background: #fcfbfb;
}
.bg-lado-direito {
  background: #f3fbff;
}
</style>
